"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateItemType = void 0;
var CreateItemType;
(function (CreateItemType) {
    CreateItemType[CreateItemType["Unknown"] = 0] = "Unknown";
    CreateItemType[CreateItemType["Form"] = 1] = "Form";
    CreateItemType[CreateItemType["Flow"] = 2] = "Flow";
    CreateItemType[CreateItemType["Class"] = 3] = "Class";
    CreateItemType[CreateItemType["Controller"] = 4] = "Controller";
    CreateItemType[CreateItemType["Entity"] = 5] = "Entity";
    CreateItemType[CreateItemType["Api"] = 6] = "Api";
    CreateItemType[CreateItemType["Designer"] = 7] = "Designer";
    CreateItemType[CreateItemType["Html"] = 8] = "Html";
    CreateItemType[CreateItemType["Css"] = 9] = "Css";
    CreateItemType[CreateItemType["Ts"] = 10] = "Ts";
    CreateItemType[CreateItemType["Tsx"] = 11] = "Tsx";
    CreateItemType[CreateItemType["SuitForm"] = 21] = "SuitForm";
})(CreateItemType || (exports.CreateItemType = CreateItemType = {}));
exports.default = CreateItemType;
//# sourceMappingURL=CreateItemType.js.map